import PropTypes from "prop-types";
import React from "react";
import i18next from "i18next";

export const direction = {
    Asc: "asc",
    Desc: "desc"
}

export function getCurrentYear() {
    return new Date().getFullYear();
}

export default function YearChooser(props) {

    const getDateRange = () => {
        const years = [];
        const startYear = new Date().getFullYear() + 1;

        if (props.firstYear) {
            years.push(props.firstYear);
        }
        for (let i = startYear;
             props.order === direction.Asc ? i <= startYear + props.range : i > startYear - props.range;
             props.order === direction.Asc ? i++ : i--) {
            years.push({Title: i, Value: i});
        }

        return years;
    }

    return <div>
        {props.label && <span>{props.label}&nbsp;</span>}
        <select value={props.currentYear} onChange={(e) => props.changeYear(e.target.value)}>
            {getDateRange().map(item => {
                return (<option value={item.Value} key={item.Value}>{item.Title}</option>)
            })}
        </select><span> {i18next.t("Year")}</span>
    </div>
}

YearChooser.propTypes = {
    currentYear: PropTypes.number,
    changeYear: PropTypes.func,
    label: PropTypes.string,
    order: PropTypes.string,
    firstYear: PropTypes.object,
    range: PropTypes.number
};

YearChooser.defaultProps = {
    order: "asc",
    range: 10
}